<main>
  <loading-overlay [isLoading]="isLoading() > 0" />

  @if (statement(); as s) {
    <nav class="crumbs">
      <i class="pi pi-folder"></i>
      <span>{{ 'Finance' | translateWF: 'Finance' }}</span>
      <i class="pi pi-angle-right"></i>
      <span>{{ 'Ledger' | translateWF: 'Ledger' }}</span>
      <i class="pi pi-angle-right"></i>
      <a class="crumb-link" routerLink="/chart-of-accounts">{{ 'COA_Title' | translateWF: 'Chart of Accounts' }}</a>
      <i class="pi pi-angle-right"></i>
      <a class="crumb-link" (click)="back()">{{ accountName() }}</a>
      <i class="pi pi-angle-right"></i>
      <span class="current">{{ s.partyName || s.partyReference }}</span>
    </nav>

    <header>
      <div>
        <a class="back-link" (click)="back()"><i class="pi pi-arrow-left"></i> {{ 'COA_BackTo' | translateWF: 'Back to' }} {{ accountName() }}</a>
        <h1>{{ s.partyName || s.partyReference }}</h1>
        <p class="subtitle">
          {{ s.partyCode }}
          @if (s.partyTaxId) {
            · {{ s.partyTaxId }}
          }
        </p>
      </div>
      <div class="buttons">
        <p-selectbutton
          [options]="scopeOptions"
          [ngModel]="includeSettled()"
          (ngModelChange)="onScopeChange($event)"
          optionLabel="label"
          optionValue="value"
          [allowEmpty]="false"
        />
        <p-button [label]="'COA_Statement' | translateWF: 'Statement'" icon="pi pi-download" variant="outlined" (click)="export()" />
      </div>
    </header>

    <div class="content">
      <!-- Outstanding summary -->
      <div class="card summary-card">
        <div>
          <span class="label">{{ 'COA_OutstandingBalance' | translateWF: 'Outstanding balance' }}</span>
          <span class="meta">{{ s.documents.length }} {{ 'COA_Documents' | translateWF: 'documents' }} · {{ 'COA_In' | translateWF: 'in' }} {{ accountName() }}</span>
        </div>
        <strong class="balance">{{ s.outstandingBalance | number: '1.2-2' }} {{ s.currency }}</strong>
      </div>

      <!-- Documents -->
      <div class="card table-card">
        <p-table [value]="s.documents" [rowHover]="true" styleClass="p-datatable-sm">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'COA_Document' | translateWF: 'Document #' }}</th>
              <th style="width: 9rem">{{ 'COA_DocType' | translateWF: 'Type' }}</th>
              <th style="width: 9rem">{{ 'COA_DocDate' | translateWF: 'Doc date' }}</th>
              <th style="width: 9rem">{{ 'COA_DueDate' | translateWF: 'Due date' }}</th>
              <th class="text-right" style="width: 11rem">{{ 'COA_DocTotal' | translateWF: 'Total' }}</th>
              <th class="text-right" style="width: 9rem">{{ 'COA_Paid' | translateWF: 'Paid' }}</th>
              <th class="text-right" style="width: 12rem">{{ 'COA_BalanceDue' | translateWF: 'Balance due' }}</th>
              @if (showFunctional()) {
                <th class="text-right" style="width: 12rem">{{ 'COA_FunctionalBalance' | translateWF: 'Functional' }} ({{ s.currency }})</th>
              }
              <th style="width: 7rem">{{ 'Status' | translateWF: 'Status' }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td class="doc-number">
                <!-- #4893 — a party statement is checked against the provider's own paperwork, filed by
                     fiscal number. Journal rows carry none and fall back to our number alone. -->
                <app-document-identity [documentNumber]="row.number" [fiscalNumber]="row.fiscalNumber" [clickable]="false" />
              </td>
              <td>{{ row.documentType }}</td>
              <td>{{ row.documentDate | date: 'dd/MM/yyyy' }}</td>
              <td>{{ row.dueDate ? (row.dueDate | date: 'dd/MM/yyyy') : '—' }}</td>
              <td class="text-right tabular-nums">{{ row.total | number: '1.2-2' }} {{ row.currency }}</td>
              <td class="text-right tabular-nums">{{ row.paid | number: '1.2-2' }} {{ row.currency }}</td>
              <td class="text-right tabular-nums font-semibold">{{ row.balanceDue | number: '1.2-2' }} {{ row.currency }}</td>
              @if (showFunctional()) {
                <td class="text-right tabular-nums">{{ row.functionalBalanceDue | number: '1.2-2' }} {{ s.currency }}</td>
              }
              <td><p-tag [severity]="statusSeverity(row.status)" [value]="row.status | translateWF: row.status" /></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr class="total-row" [class.ties]="s.tiesOut">
              <td [attr.colspan]="showFunctional() ? 7 : 6">
                <i class="pi" [ngClass]="s.tiesOut ? 'pi-check-circle' : 'pi-exclamation-circle'"></i>
                {{ 'COA_BalanceDue' | translateWF: 'Balance due' }} ·
                {{ s.tiesOut ? ('COA_TiesToLine' | translateWF: 'ties to subledger line') : ('COA_DoesNotTieLine' | translateWF: 'does not tie to subledger line') }}
              </td>
              <td class="text-right tabular-nums font-semibold">{{ s.documentsTotal | number: '1.2-2' }} {{ s.currency }}</td>
              <td></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="showFunctional() ? 9 : 8" class="empty-cell">
                <i class="pi pi-inbox"></i>
                @if (includeSettled()) {
                  <p>{{ 'COA_NoAnyDocuments' | translateWF: 'No documents for this party.' }}</p>
                } @else {
                  <p>{{ 'COA_NoDocuments' | translateWF: 'No open documents for this party.' }}</p>
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  }
</main>
